<template>
  <b-row>
    <b-col>
      <b-button-group v-b-hover="handleHover" vertical>
        <b-button size="sm" v-if="reassigned === false"
          :variant="isHovered ? 'success' : 'primary'" 
          class="mb-2"
          v-b-tooltip.hover.right title="Move / Relocate / Transfer"
          @click="$emit('relocate')"
        >
          <b-icon-arrow-left-right aria-label="Relocate"></b-icon-arrow-left-right>
        </b-button>
      </b-button-group>
    </b-col>
  </b-row>
</template>

<script>
import {
  BIconArrowLeftRight,
} from 'bootstrap-vue'
export default {
  components: {
    BIconArrowLeftRight
  },
  props: {
    reassigned : {
      Type: Boolean
    }
  },
  data() {
    return {
      isHovered: false
    }
  },
  methods: {
    handleHover(hovered) {
      this.isHovered = hovered
    }
  }
}
</script>
